<template>
  <form-model title="验收单填写" width="700" ref="formModel">
    <Button slot="btn" type="primary" @click="qianzi">提交验收</Button>
  </form-model>
</template>
<script>
import fields from "./forms/fields";
export default {
  data() {
    return {
      title: "",
      forms: [],
      item: {
        itemList: [],
        startTime: Date.now(),
        endTime: Date.now(),
        name: "",
        content: "",

      },
      searchItem: {},
    };
  },
  methods: {
    //https://cloud.ly-gps.com/cloud-rmm-server-dpm/repair
    reach(v) {
      this.forms = fields[v.key];
      this.item.title = v.title;
      this.item.job = v.nodeName;
      this.item.formId = v.docId;
      this.searchItem.id = v.docId;
      this.getFormModel(v.formId);
      this.$refs.formModel.reach(this.forms, this.item);
    },
    qianzi() {
      var a = this.$refs.formModel.getItem();
      console.log(this.item);
      if (!a) {
        return;
      }

      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dpm + "/accept/update",
        data: this.item,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.$refs.formModel.close();
          this.$emit('ok');
        }
      });
    },

    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.serverUrl + "/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;

          if (data != null) {
            this.item.itemList = data.itemList;
            for (let i = 0; i < this.forms.length; i++) {
              if (this.forms[i].key == "itemList") {
                this.forms[i].selectItems = data.itemList;
              }
            }
            //如果填写验收单，要带出来
            var ac = data.accept;
            console.log(ac);
            if (ac.id) {
              this.item.content = ac.content;
              this.item.name = ac.name;
              this.item.remark = ac.remark;
              this.item.startTime = ac.startTime==null?Date.now():ac.startTime;
              this.item.endTime = ac.endTime==null?Date.now():ac.endTime;
            }
            this.item.id = data.acceptId;
          }
        }
      });
    },
    getFormModel(id) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/form/info",
        data: { id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var v = res.data.data;
          this.serverUrl = v.serverUrl;
          this.title = v.name;
          this.getDetail();
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yanshou.vue